import React from 'react'

export default function form() {
    return (
        <>
            <div className='py-20 bg-[#FFF5F3] relative'>
                <img
                    src="/assets/temple new.webp"
                    className="absolute top-2 left-1/2 -translate-x-1/2 h-96 opacity-10"
                    alt="leftline"
                />
                <div></div>
                <div className='max-w-7xl mx-auto'>
                    <img
                        src="/assets/left-line.svg"
                        className="absolute left-0 top-2"
                        alt="leftline"
                    />
                    <div>
                        <div className='max-w-7xl mx-auto px-4 relative z-10'>
                            <h2 className='text-5xl mb-10 text-center' style={{ fontFamily: 'Philosopher, sans-serif' }}>Gunatit Satsang <span className='text-primary mb-9'>Shibir-17</span> Form</h2>
                            <h6 className='text-2xl mb-10 text-center'>Gunatit Satsang Shibir will be held at Rishikesh, from 19 to 25 octomber... <span className='text-primary mb-9 underline'>Learn more</span></h6>
                            <div className=' w-full justify-center flex'>
                                <button className='bg-primary text-white px-6 py-3 rounded-3xl hover:bg-red-900 transition-all'>Apply From Mahima App</button>
                            </div>
                        </div>
                    </div>
                    <img
                        src="/assets/left-line.svg"
                        className="absolute right-0 bottom-2"
                        style={{ transform: 'scaleX(-1) scaleY(-1)' }}
                        alt="leftline"
                    />
                </div>
            </div>
        </>
    )
}
